import React, { useMemo } from 'react';
import { TableCell, TableRow, withStyles } from '@material-ui/core';

import styles from '../styles/rangesDetails';
import Optional from '../../../utils/optional';
import { formatDate } from '../actions/mapInactiveCellValue';
import {
  isDefined,
  isStringDefined,
  isUndefined
} from '../../../utils/isDefined';
import flowRight from 'lodash.flowright';
import withSettings from '../../../utils/withSettings';
import StatusCell from './StatusCell';
import ConnectRangesActionButtons from './ConnectRangesActionButtons';
import withUserCheck from '../../../utils/withUserCheck';

const ConnectNumberDetails = ({
  data,
  classes,
  settings,
  resetValues,
  isAdminUser
}) => {
  const inactiveText = useMemo(() => {
    const { founded } = data;

    if (isUndefined(founded)) {
      return '';
    }

    const { och_inactive_at, future_status } = founded;

    return `${Optional(formatDate(och_inactive_at)).or('')} ${
      isStringDefined(future_status) ? `- ${future_status}` : ''
    }`;
  }, [data]);

  return (
    <>
      <TableRow>
        <TableCell className={classes.iconCell}>
          <div>
            {isDefined(data.founded) ? (
              <i
                style={{ color: settings.colors.success, fontSize: '20px' }}
                className="fa fa-check-circle"
              ></i>
            ) : (
              <i
                style={{ color: settings.colors.danger, fontSize: '20px' }}
                className="fa fa-times-circle"
              ></i>
            )}
          </div>
        </TableCell>
        <TableCell className={classes.numberCell}>
          <div className={classes.number}>
            {data.number}
            {data.function === 'USER' && data.alias === true && (
              <div className={classes.aliasBox}>Alias</div>
            )}
          </div>
        </TableCell>
        <TableCell className={classes.functionCell}>
          {Optional(data.function).or('')}
        </TableCell>
        <TableCell className={classes.numberCell}>
          {isDefined(data.founded) && (
            <StatusCell status={data.founded?.status} />
          )}
        </TableCell>
        <TableCell className={classes.nameCell}>
          {Optional(formatDate(data.founded?.och_active_at)).or('')}
        </TableCell>
        <TableCell className={classes.nameCell}>{inactiveText}</TableCell>
        {isAdminUser && (
          <TableCell className={classes.nameCell}>{data.ochOperator}</TableCell>
        )}
        <TableCell className={classes.nameCell}>
          <ConnectRangesActionButtons
            numberRange={data.founded}
            resetValues={resetValues}
            isBeTable={false}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default flowRight(
  withUserCheck,
  withSettings,
  withStyles(styles)
)(ConnectNumberDetails);
